import classes from './MainNavigation.module.css';
import { Fragment } from 'react';
import { Link, NavLink, useRouteLoaderData, Form } from 'react-router-dom';
import logo from '../assests/drtechbuddy.png';
import { FaWhatsapp } from 'react-icons/fa';
const MainNavigation = () => {
  const token = useRouteLoaderData('root');
  return (
    <Fragment>

      <header className={classes.header}>
        <div className='container'>
          <nav className="navbar navbar-expand-lg">
            <div className="container-fluid p-0">
              <Link className={classes.brand} to="/"><img className={classes.logo} src={logo} alt="logo" /></Link>
              <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mynavbar">
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse" id="mynavbar">
                <ul className={`navbar-nav ms-lg-4 ${classes.navLinks}`}>
                  <li className="nav-item">
                    <NavLink to="/" className={({ isActive }) => isActive ? `${classes.menu} ${classes.active}` : classes.menu} end> Login </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to="/contact" className={({ isActive }) => isActive ? `${classes.menu} ${classes.active}` : classes.menu}> Contact Us </NavLink>
                  </li>
                  {/* <li className="nav-item">
                    <NavLink to="/how-it-works" className={({ isActive }) => isActive ? `${classes.menu} ${classes.active}` : classes.menu}> How it Works </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to="/pricing" className={({ isActive }) => isActive ? `${classes.menu} ${classes.active}` : classes.menu}> Pricing </NavLink>
                  </li> */}
                </ul>
                <div className="ms-auto d-flex align-items-center gap-3">
                  <div className={classes.directContact}>
                    <a href="https://wa.me/917559383489" target="_blank" rel="noopener noreferrer" className={classes.contactLink}>
                      <FaWhatsapp className={classes.waIcon} />
                      <span>+91 75593 83489</span>
                    </a>
                  </div>
                  <ul className="navbar-nav">
                    {token &&
                      <Form action="/logout" method="post">
                        <button className={classes.logoutBtn}>Logout</button>
                      </Form>
                    }
                  </ul>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </header>

    </Fragment>
  );
}

export default MainNavigation;